<script setup lang="ts">
import LogoSvg from '@/assets/img/logo-byulo.svg?component';

type PropsType = {
    visible?: boolean;
};

withDefaults(defineProps<PropsType>(), { visible: false });
</script>

<template>
    <Transition name="fade">
        <div
            v-if="visible"
            class="buylo-splash"
        >
            <LogoSvg class="buylo-splash__logo" />
        </div>
    </Transition>
</template>

<style scoped lang="scss">
.buylo-splash {
    position: fixed;
    inset: 0;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgb(var(--v-theme-background));
}

.buylo-splash__logo {
    width: 120px;
    height: auto;
    animation: logo-pulse 1000ms ease-in-out infinite;
}

@keyframes logo-pulse {
    0%,
    100% {
        transform: scale(2);
    }
    50% {
        transform: scale(1.9);
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 150ms ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

@media (prefers-reduced-motion: reduce) {
    .buylo-splash__logo {
        animation: none;
    }
}
</style>
